// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN

Sentry.init({
	dsn:
		SENTRY_DSN ||
		'https://f6dad907ea014e2c82d2fd51e9f9a3a7@o4503926874374144.ingest.sentry.io/4503941582749696',
	// Adjust this value in production, or use tracesSampler for greater control
	tracesSampleRate: 1.0,
	enabled: process.env.NODE_ENV !== 'development',
	ignoreErrors: ["ReferenceError: Can't find variable: gmo"],
	// ...
	// Note: if you want to override the automatic release value, do not set a
	// `release` value here - use the environment variable `SENTRY_RELEASE`, so
	// that it will also get attached to your source maps
})
